import BlockWrapper from './BlockWrapper';

export default BlockWrapper;
